module.exports = __webpack_public_path__ + "img/lemon-drop-cookies.78d6b57f.jpg";